import * as React from "react"
import styled from "styled-components"

import { mixins } from "../theme";

const Wrapper = styled.div<{ padding: number; height?: number }>`
    width: 100%;
    box-sizing: border-box;
    padding: ${(props) => props.padding}px;

    align-items: center;
    display: flex;

    @-webkit-keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }

    @keyframes placeload {
        0% {
            background-position: -468px 0;
        }
        100% {
            background-position: 468px 0;
        }
    }
`
Wrapper.displayName = "PlaceholderWrapper";

const Content = styled.div<{ minWidth: number; height: number, useDarkMode?: boolean }>`
    ${mixins.rounded};
    background-color: ${(props) => props.color};
    height: ${(props) => props.height}px;
    width: 100%;
    min-width: ${({ minWidth }) => minWidth}px;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeload;
    animation-timing-function: linear;
    ${(props: any) =>
  props.theme.style === "dark" && props.useDarkMode
    ? "background: -webkit-linear-gradient(left, #111 8%, #222 18%, #111 33%);"
    : "background: -webkit-linear-gradient(left, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);"};
    -webkit-background-size: 800px 104px;
    background-size: 1200px 104px;
    position: relative;
`
Content.displayName = "PlaceholderContent";

export interface PlaceholderProps {
  height?: number
  padding?: number
  minWidth?: number
  color?: string
  style?: React.CSSProperties
  contentStyle?: React.CSSProperties
  useDarkMode?: boolean
  children?: React.ReactNode | string;
}

export const Placeholder: React.FC<PlaceholderProps> = ({
                                                   height = 12,
                                                   padding = 3,
                                                   color = "rgba(0,0,0, 0.05)",
                                                   minWidth = 100,
                                                   style,
                                                   contentStyle,
                                                   useDarkMode = false,
                                                 }) => (
  <Wrapper padding={padding} style={style}>
    <Content style={contentStyle} color={color} height={height} minWidth={minWidth} useDarkMode={useDarkMode || false} />
  </Wrapper>
)
